import {
  APP_OPTIONS, AVO_PHASE_BEFORE, AVO_PHASE_DURING, AVO_PHASE_AFTER,
} from '../config/constants';

export enum Phase {
  BEFORE = AVO_PHASE_BEFORE,
  DURING = AVO_PHASE_DURING,
  AFTER = AVO_PHASE_AFTER,
}

export default function usePhaseState(): Phase {
  const { startDate, endDate } = APP_OPTIONS.parameters.avoDates as {
    startDate: number;
    endDate: number;
  };

  const currentTimeStamp = Math.floor(Date.now() / 1000);

  if (currentTimeStamp < startDate) {
    return Phase.BEFORE;
  }
  if (currentTimeStamp < endDate) {
    return Phase.DURING;
  }
  return Phase.AFTER;
}
